var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessRecommend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.998 41.7656C15.7643 41.7656 8.24805 34.2493 8.24805 25.0156C8.24805 15.7819 15.7643 8.26562 24.998 8.26562C34.2318 8.26562 41.7481 15.7819 41.7481 25.0156C41.7481 34.2493 34.2318 41.7656 24.998 41.7656ZM24.998 43.7656C14.6598 43.7656 6.24805 35.3539 6.24805 25.0156C6.24805 14.6773 14.6598 6.26562 24.998 6.26562C35.3363 6.26562 43.7481 14.6773 43.7481 25.0156C43.7481 35.3539 35.3363 43.7656 24.998 43.7656ZM35.0834 19.4695C35.4739 19.079 35.4739 18.4458 35.0834 18.0553C34.6929 17.6647 34.0597 17.6647 33.6692 18.0553L22.918 28.8065L17.3751 23.2636C16.9846 22.8731 16.3514 22.8731 15.9609 23.2636C15.5703 23.6541 15.5703 24.2873 15.9609 24.6778L22.2109 30.9278L22.918 31.6349L23.6251 30.9278L35.0834 19.4695Z",
    fill: "#202635"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessRecommend);
export default __webpack_public_path__ + "static/media/successRecommend.a815c721.svg";
export { ForwardRef as ReactComponent };